import React from 'react';

// Services & Helpers
import API from 'API';
import TextHelpers from 'helpers/TextHelpers';

// Components
import Loader from 'components/common/Loader';
import SuperTable from 'components/common/SuperTable';
import EditDiscountModal from 'components/setup/EditDiscountModal';

//-----------------------------------------------------------------

class SetupDiscounts extends React.Component {

    constructor(props) {
        super(props);

        this.editDiscountModalRef = React.createRef();

        this.state = {
            isLoading: true,
        };
    }

    componentDidMount() {
        this.props.fns.setTitle('Discounts setup');
        this.load();
    }

    async load() {
        const discounts = await API.call('discount/list');
        this.setState({
            isLoading: false,
            discounts
        });
    }

    async open(id) {
        await this.editDiscountModalRef.current.open({
            id
        });
        this.load();
    }

    async add() {
        await this.editDiscountModalRef.current.open({
        });
        this.load();
    }
    
    //---------------------------------------------------------------------------------------------------------------

    render() {
        const {
            isLoading,
            discounts
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <section className="control-panel sticky">

                <h1>Discounts</h1>

                <button type="button" className="ms-auto btn btn-primary" onClick={() => this.add()}>
                    Add Discount
                </button>

            </section>

            <section>

                <SuperTable
                    className="discounts-table table table-bordered clickable mb-0"
                    rows={discounts}
                    keyAccessor={discount => discount.id}
                    cols={{
                        name: { label: 'Name' },
                        description: { label: 'Description' },
                        discount: {
                            label: 'Discount',
                            getValue: (colInfo, discount) => 
                                discount.discountType == 'Fixed' ? TextHelpers.formatCurrency(discount.discountAmount) : 
                                (discount.discountAmount || 0) + '%'
                        },
                        startDate: {
                            label: 'Start Date',
                            type: 'date'
                        },
                        expiryDate: {
                            label: 'Expiry Date',
                            type: 'date'
                        }
                    }}
                    onClick={(discount, e) => this.open(discount.id)}
                    emptyText="No discounts to show"
                />

            </section>

            <EditDiscountModal
                ref={this.editDiscountModalRef}
            />

        </>);
    }
    
}

export default SetupDiscounts;